import {
  IPublicClientApplication,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

interface B2cEnvConfig {
  authority: string;
  knownAuthorities: string[];
  clientId: string;
  scopes: string[];
}

export function buildMsalInstance(): IPublicClientApplication {
  const b2c: B2cEnvConfig = environment.b2c;
  return new PublicClientApplication({
    auth: {
      clientId: b2c.clientId,
      authority: b2c.authority,
      knownAuthorities: b2c.knownAuthorities,
      redirectUri: '/',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: 'localStorage',
    },
    system: {
      loggerOptions: {
        logLevel: environment.production ? LogLevel.Warning : LogLevel.Info,
        loggerCallback: (level, message) => {
          if (level === LogLevel.Error) {
            console.error(message);
          } else if (level === LogLevel.Warning) {
            console.warn(message);
          } else if (level === LogLevel.Info && !environment.production) {
            console.info(message);
          }
        },
        piiLoggingEnabled: false,
      },
    },
  });
}

export function getB2cScopes(): string[] {
  return [...environment.b2c.scopes];
}
